// GENERATED CODE - DO NOT EDIT
export const GetItSoonerOptionTypeMap = {
    ONE_TIME_CASH_PAY: 'one_time_cash_pay',
    VACATION_SUPPLY: 'vacation_supply',
    LOST_MEDICATION: 'lost_medication',
    RUN_INSURANCE: 'run_insurance',
};
//# sourceMappingURL=get_it_sooner.js.map